import React from 'react';
import { useLocation } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { Box, Container, Tabs, Tab } from '@material-ui/core';
import { parse, stringify } from 'query-string';
import { TabTradeHistory } from './components';

const TradeHistory = () => {
  const location = useLocation();
  const { tab, ...query } = parse(location.search);
  const { t } = useTranslation();

  const tabs = [
    { id: 1, code: 'purchases', label: t('Purchases'), component: <TabTradeHistory isPurchase /> },
    { id: 2, code: 'sales', label: t('Sales'), component: <TabTradeHistory /> },
  ];
  const [activeTab, setActiveTab] = React.useState((tabs.find((item) => item.code === tab) ?? tabs[0]).code);

  const handleChangeTab = (_, nextTab) => {
    setActiveTab(nextTab);
    window.history.replaceState(null, null, '?' + stringify({ ...query, tab: nextTab }));
  };

  return (
    <Box>
      <Container maxWidth='lg'>
        <Tabs value={activeTab} onChange={handleChangeTab}>
          {tabs.map((tab) => (
            <Tab key={tab.id} label={tab.label} value={tab.code} />
          ))}
        </Tabs>
      </Container>
      {tabs.map((tab) => (
        <Box key={tab.id} hidden={tab.code !== activeTab} py={2}>
          {tab.component}
        </Box>
      ))}
    </Box>
  );
};

export default TradeHistory;
